// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3cjUl","text":"SelectPayment_text__UrK5N","title":"SelectPayment_title__BPLgB","btn":"SelectPayment_btn__2JiI3"};